<template>
  <div>
    <div class="mrB20" />
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_WORK_ID')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-10">
          <div class="comm_label">
            <sui-text-field
              v-model="frame0.frms.taskId"
              :disabled="true"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_TASK_UP_ID')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-10">
          <div
            class="comm_label"
          >
            <sui-text-field
              v-model="frame0.frms.taskUpId"
              :disabled="true"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_WORK_NM')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-10">
          <cmp-mlng-editor
            ref="mlngEditor"
            :pageId="pageId"
            :multiLanguageId="multiLanguageId"
            :vertical="false"
            :editable="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_USE_YN')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-10">
          <sui-radio
            v-model="frame0.frms.taskUseYn"
            value="Y"
          >
            Yes
          </sui-radio>
          <sui-radio
            v-model="frame0.frms.taskUseYn"
            value="N"
          >
            No
          </sui-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_ARRAY_ORDER')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-10">
          <sui-text-field
            ref="sortOrder"
            v-model="frame0.frms.arylOrd"
            :disabled="false"
            :readonly="false"
            maxlength="4"
            mask="number"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_WORK_CONTENTS')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-10">
          <textarea
            v-model="frame0.frms.taskContents"
            rows="9"
          />
        </div>
      </div>
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:update="'PGE_CMY_00021'"
          type="button"
          class="comm_btn_solid"
          @click="onSave"
        >
          {{ $t("MSG_BTN_SAVE") }}
        </sui-button>
      </div>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00021_T01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    selectedTreeData: {
      type: Object,
      required: true,
    },
    // multiLanguageId: {
    //   type: String,
    //   default: null,
    // },
  },
  data() {
    return {
      // Codes
      frame0: {
        frms: {
          taskUseYn: '',
          taskId: '',
          taskUpId: '',
          arylOrd: '',
          taskContents: '',
          taskMlngId: '',
        },
      },
      multiLanguageId: '',
      searchFieldOldText: '',
    };
  },
  computed: {},
  watch: {
    selectedTreeData(selectObj) {
      if (selectObj) {
        const frm = this.frame0.frms;
        frm.taskId = selectObj.taskId;
        frm.taskUpId = selectObj.parentTaskId;
        frm.taskUseYn = selectObj.taskUseYn;
        frm.arylOrd = utils.toCharNum(selectObj.arylOrd);
        frm.taskContents = selectObj.taskContents;
        frm.taskMlngId = selectObj.taskMlngId;
        // 메시지자원값 다국어 조회
        this.multiLanguageId = selectObj.taskMlngId;

        // this.selectDataFormInput(selectObj);

        this.saveSnapshot(this.makeSnapshot());
      }
    },
  },
  datasets: [],
  mounted() {
    // this.$nextTick(() => {
    //   this.selectDataFormInput(this.$props.selectedTreeData);
    // });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    makeSnapshot() {
      return utils.assign({}, this.frame0.frms);
    },
    // selectDataFormInput(obj) {
    //   this.frame0.taskId = obj.taskId;
    //   this.frame0.taskUpId = obj.parentTaskId;
    //   this.frame0.phesUseYn = obj.phesUseYn;
    //   this.frame0.taskUseYn = obj.taskUseYn;
    //   this.frame0.arylOrd = utils.toCharNum(obj.arylOrd);
    //   this.frame0.taskContents = obj.taskContents;
    //   this.frame0.taskMlngId = obj.taskMlngId;
    //   // 메시지자원값 다국어 조회
    //   this.multiLanguageId = obj.taskMlngId;
    //   // this.$refs.mlngEditor.searchMlngDataById(obj.taskMlngId);
    // },
    onKeyUpInput() { // 숫자외 입력제한
      // const newSortOrder = this.$refs.sortOrder.txtField;
      const newSortOrder = this.frame0.frms.arylOrd;

      if (utils.isOnlyDigit(newSortOrder)) {
        this.searchFieldOldText = newSortOrder;
        // return true;
      }

      this.$refs.sortOrder.txtField = this.searchFieldOldText;

      if (utils.isOnlyDigit(this.$refs.sortOrder.txtField) === false) {
        utils.messageBox('warning', this.$t('MSG_ALT_ONLY_NUMBER'), null, () => {
          this.$refs.sortOrder.setFocus();
        });
      }

      if (this.frame0.frms.arylOrd === '') {
        this.$refs.sortOrder.txtField = '';
        this.searchFieldOldText = '';
      }
      // return false;
    },
    conFirm(type, value, subValue) {
      utils.messageBox(type, value, subValue, this.onClose);
    },
    onSave() {
      if (utils.isEmpty(utils.trim(this.frame0.frms.taskId)) === true) {
        this.conFirm('error', utils.strFormat(this.$t('MSG_ALT_INP_ID'), this.$t('MSG_TXT_WORK_ID')), null);
        return;
      }

      if (utils.isEmpty(utils.trim(this.$refs.mlngEditor.$refs.localTxtFld.value)) === true) {
        this.conFirm('error', utils.strFormat(this.$t('MSG_ALT_INP_ID'), this.$t('MSG_TXT_WORK_NM')), null);
        return;
      }

      if (utils.isEmpty(utils.trim(this.$refs.mlngEditor.$refs.globalTxtFld.value))) {
        this.conFirm('error', utils.strFormat(this.$t('MSG_ALT_INP_ID'), this.$t('MSG_ALT_GLOBAL_ENM')), null);
        return;
      }

      if (utils.isEmpty(this.frame0.frms.arylOrd) === true) {
        this.conFirm('error', utils.strFormat(this.$t('MSG_ALT_INP_ID'), this.$t('MSG_TXT_ARRAY_ORDER')), null);
        return;
      }

      if (utils.isEmpty(this.frame0.frms.taskContents) === true) {
        this.conFirm('error', utils.strFormat(this.$t('MSG_ALT_INP_ID'), this.$t('MSG_TXT_WORK_CONTENTS')), null);
        return;
      }

      const multiLanguageList = this.$refs.mlngEditor.getMlngEditingInfoFillEmptyWithGlobal();

      const dataParams = {
        taskId: this.frame0.frms.taskId,
        taskUseYn: this.frame0.frms.taskUseYn,
        arylOrd: this.frame0.frms.arylOrd,
        taskContents: this.frame0.frms.taskContents,
        taskMlngId: this.frame0.frms.taskMlngId,
        multiLanguageList,
      };

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        console.log(this.pageId);
        http.request(this.pageId, 'DTS_CMY_00042', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null);
          this.$emit('onSearchClick');
        }).catch(error => {
          console.log(error);
        });
      });
    },
  },
};
</script>
<style scoped>
</style>
